import { __assign, __extends } from "tslib";
import { GandalfLoginAssociationServiceException as __BaseException } from "./GandalfLoginAssociationServiceException";
export var ValidationExceptionFieldFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, __assign({ name: "ValidationException", $fault: "client" }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.fieldList = opts.fieldList;
        return _this;
    }
    return ValidationException;
}(__BaseException));
export { ValidationException };
var AccessDeniedException = (function (_super) {
    __extends(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "AccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        return _this;
    }
    return AccessDeniedException;
}(__BaseException));
export { AccessDeniedException };
export var BatchDeleteLoginAssociationInputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteLoginAssociationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteLoginAssociationOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LoginAssociationErrorType;
(function (LoginAssociationErrorType) {
    LoginAssociationErrorType["ASSOCIATION"] = "ASSOCIATION";
    LoginAssociationErrorType["INSERTION"] = "INSERTION";
    LoginAssociationErrorType["REASSOCIATION"] = "REASSOCIATION";
    LoginAssociationErrorType["RETRIEVIAL"] = "RETRIEVIAL";
})(LoginAssociationErrorType || (LoginAssociationErrorType = {}));
export var BatchDeleteLoginAssociationFailedOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteLoginAssociationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var InternalServerException = (function (_super) {
    __extends(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalServerException", $fault: "server" }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        return _this;
    }
    return InternalServerException;
}(__BaseException));
export { InternalServerException };
var ThrottlingException = (function (_super) {
    __extends(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, __assign({ name: "ThrottlingException", $fault: "client" }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        _this.$retryable = {
            throttling: true,
        };
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        return _this;
    }
    return ThrottlingException;
}(__BaseException));
export { ThrottlingException };
export var BatchFindLoginAssociationInputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchFindLoginAssociationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var Exclusivity;
(function (Exclusivity) {
    Exclusivity["EXCLUSIVE"] = "EXCLUSIVE";
    Exclusivity["INCLUSIVE"] = "INCLUSIVE";
})(Exclusivity || (Exclusivity = {}));
export var BatchFindLoginAssociationOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchFindLoginAssociationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetIdentityProviderExclusivityInputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetIdentityProviderExclusivityInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetIdentityProviderExclusivityOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetIdentityProviderExclusivityNotFoundOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetIdentityProviderExclusivityOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetLoginAssociationInputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetLoginAssociationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetLoginAssociationFailedOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetLoginAssociationOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchGetLoginAssociationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutLoginAssociationInputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutLoginAssociationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutLoginAssociationOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutLoginAssociationFailedOutputListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutLoginAssociationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAccountLinkStatusWithTokenJustificationCorsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAccountLinkStatusWithTokenJustificationCorsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAssociationWithTokenValidationCorsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAssociationWithTokenValidationCorsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var InvalidGandalfTokenException = (function (_super) {
    __extends(InvalidGandalfTokenException, _super);
    function InvalidGandalfTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidGandalfTokenException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidGandalfTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidGandalfTokenException.prototype);
        return _this;
    }
    return InvalidGandalfTokenException;
}(__BaseException));
export { InvalidGandalfTokenException };
var MissingAttributeInGandalfTokenException = (function (_super) {
    __extends(MissingAttributeInGandalfTokenException, _super);
    function MissingAttributeInGandalfTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "MissingAttributeInGandalfTokenException", $fault: "client" }, opts)) || this;
        _this.name = "MissingAttributeInGandalfTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MissingAttributeInGandalfTokenException.prototype);
        return _this;
    }
    return MissingAttributeInGandalfTokenException;
}(__BaseException));
export { MissingAttributeInGandalfTokenException };
export var LinkStatus;
(function (LinkStatus) {
    LinkStatus["LINKABLE"] = "LINKABLE";
    LinkStatus["NOT_LINKABLE"] = "NOT_LINKABLE";
})(LinkStatus || (LinkStatus = {}));
export var PutAccountLinkStatusWithTokenJustificationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAccountLinkStatusWithTokenJustificationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var InvalidValidationTokenException = (function (_super) {
    __extends(InvalidValidationTokenException, _super);
    function InvalidValidationTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidValidationTokenException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidValidationTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidValidationTokenException.prototype);
        return _this;
    }
    return InvalidValidationTokenException;
}(__BaseException));
export { InvalidValidationTokenException };
var LoginAssociationException = (function (_super) {
    __extends(LoginAssociationException, _super);
    function LoginAssociationException(opts) {
        var _this = _super.call(this, __assign({ name: "LoginAssociationException", $fault: "client" }, opts)) || this;
        _this.name = "LoginAssociationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LoginAssociationException.prototype);
        _this.loginAssociationErrorType = opts.loginAssociationErrorType;
        return _this;
    }
    return LoginAssociationException;
}(__BaseException));
export { LoginAssociationException };
export var PutAssociationWithTokenValidationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAssociationWithTokenValidationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
